import React from "react";
import Image from "next/image";

const SimpleImageSlider = ({ images, interval = 2000, isLightTheme }) => {
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [isHovered, setIsHovered] = React.useState(false);
  const [isTransitioning, setIsTransitioning] = React.useState(true);

  const extendedImages = [...images, ...images, ...images];
  const startIndex = images.length;

  React.useEffect(() => {
    if (currentIndex === 0) {
      setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(startIndex);
      }, 500);
    } else if (currentIndex === extendedImages.length - images.length) {
      setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(startIndex);
      }, 500);
    }
  }, [currentIndex, startIndex, extendedImages.length, images.length]);

  React.useEffect(() => {
    if (isHovered) return;

    const timer = setInterval(() => {
      setIsTransitioning(true);
      setCurrentIndex((prev) => prev + 1);
    }, interval);

    return () => clearInterval(timer);
  }, [interval, isHovered]);

  const goToPrevious = () => {
    setIsTransitioning(true);
    setCurrentIndex((prev) => prev - 1);
  };

  const goToNext = () => {
    setIsTransitioning(true);
    setCurrentIndex((prev) => prev + 1);
  };

  const goToSlide = (index) => {
    setIsTransitioning(true);
    setCurrentIndex(startIndex + index);
  };

  if (images.length === 0) return null;

  const activeDotIndex = ((currentIndex - startIndex) % images.length + images.length) % images.length;

  return (
    <div
      style={{
        width: "100%",
        height: "550px",
        overflow: "hidden",
        borderRadius: "10px",
        position: "relative",
        backgroundColor: isLightTheme ? "#ffffff" : "#0f172a",
      }}

      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        style={{
          display: 'flex',
          height: '100%',
          width: `${extendedImages.length * 100}%`,
          transform: `translateX(-${currentIndex * (100 / extendedImages.length)}%)`,
          transition: isTransitioning ? 'transform 0.5s ease-in-out' : 'none',
        }}
      >
        {extendedImages.map((src, index) => (
          <div
            key={index}
            style={{
              width: `${100 / extendedImages.length}%`,
              height: '100%',
              position: 'relative',
              flexShrink: 0,
            }}
          >
            <Image
              src={src}
              alt={`ELMSPLUS Platform Feature Slide ${(index % images.length) + 1}`}
              fill
              style={{
                objectFit: 'contain',
              }}
            />
          </div>
        ))}
      </div>

      <button
        onClick={goToPrevious}
        style={{
          position: 'absolute',
          left: '15px',
          top: '50%',
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          border: 'none',
          borderRadius: '50%',
          width: '45px',
          height: '45px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '20px',
          color: '#333',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          transition: 'all 0.3s ease',
          opacity: isHovered ? 1 : 0,
          zIndex: 10,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#a259e0';
          e.currentTarget.style.color = '#fff';
          e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
          e.currentTarget.style.color = '#333';
          e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
        }}
      >
        ‹
      </button>

      <button
        onClick={goToNext}
        style={{
          position: 'absolute',
          right: '15px',
          top: '50%',
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          border: 'none',
          borderRadius: '50%',
          width: '45px',
          height: '45px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '20px',
          color: '#333',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          transition: 'all 0.3s ease',
          opacity: isHovered ? 1 : 0,
          zIndex: 10,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#a259e0';
          e.currentTarget.style.color = '#fff';
          e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
          e.currentTarget.style.color = '#333';
          e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
        }}
      >
        ›
      </button>

      <div style={{ position: 'absolute', bottom: '7px', width: '100%', textAlign: 'center', zIndex: 10 }}>
        {images.map((_, index) => (
          <span
            key={index}
            style={{
              display: 'inline-block',
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              background: activeDotIndex === index ? '#4a90e2' : 'rgba(255, 255, 255, 0.6)',
              margin: '0 5px',
              cursor: 'pointer',
              transition: 'background 0.3s',
              border: '1px solid rgba(0,0,0,0.1)',
            }}
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default SimpleImageSlider;
